module.exports = __webpack_public_path__ + "img/para_de_minas_setcemg.d04c514b.png";